import { InvTextConsentView } from '@elva/ui';

/**
 * Patient-facing aligner-text consent page (amendment 33 §2). No app shell,
 * no staff nav, no date-of-birth gate — reached from the "Yes, text me too"
 * button in email 1 at {practice}.elva.ai/p/texts/<code>.
 */
export function InvTextConsentPublicPage() {
  return <InvTextConsentView />;
}
